import { getUsernameEmailSafetyPromptStorageKey } from '../constants';

import { setLocalStorageItem } from '@/modules/storage';

export function setUsernameEmailSafetyPromptStatus(userId: number): void {
  setLocalStorageItem(
    getUsernameEmailSafetyPromptStorageKey(userId),
    JSON.stringify({ dismissedAt: new Date().toISOString() })
  );
}
